var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.639 10.975l2.489-1.62c.44-.287.938-.475 1.458-.552l1.795-.264a1.58 1.58 0 011.744 1.108l.002.008a7.942 7.942 0 01-.011 4.6 1.58 1.58 0 01-1.687 1.107l-1.404-.157a3.648 3.648 0 01-1.54-.539l-2.846-1.794v-1.897z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.639 10.975l2.489-1.62c.44-.287.938-.475 1.458-.552l1.795-.264a1.58 1.58 0 011.744 1.108l.002.008a7.942 7.942 0 01-.011 4.6 1.58 1.58 0 01-1.687 1.107l-1.404-.157a3.648 3.648 0 01-1.54-.539l-2.846-1.794v-1.897z",
    stroke: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.096 10.975l-2.49-1.62a3.652 3.652 0 00-1.457-.552l-1.795-.264a1.58 1.58 0 00-1.745 1.108l-.002.008a7.947 7.947 0 00.012 4.6 1.58 1.58 0 001.687 1.107l1.404-.157a3.648 3.648 0 001.54-.539l2.846-1.794v-1.897z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.096 10.975l-2.49-1.62a3.652 3.652 0 00-1.457-.552l-1.795-.264a1.58 1.58 0 00-1.745 1.108l-.002.008a7.947 7.947 0 00.012 4.6 1.58 1.58 0 001.687 1.107l1.404-.157a3.648 3.648 0 001.54-.539l2.846-1.794v-1.897z",
    stroke: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.83 13.69h-2.064a.705.705 0 01-.706-.704v-2.058c0-.389.316-.705.706-.705h2.064c.39 0 .706.316.706.705v2.058a.705.705 0 01-.706.704",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.83 13.69h-2.064a.705.705 0 01-.706-.704v-2.058c0-.389.316-.705.706-.705h2.064c.39 0 .706.316.706.705v2.058a.705.705 0 01-.706.704z",
    stroke: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    d: "M13.536 11.536l2.456-.643M13.536 12.201l1.467.303M9.807 11.536l-2.456-.643M9.807 12.201l-1.467.303"
  }))));
}
export default SvgRoomService;